import { render, staticRenderFns } from "./VistaSeleccionConsorcios.vue?vue&type=template&id=2dbb81be"
import script from "./VistaSeleccionConsorcios.vue?vue&type=script&lang=js"
export * from "./VistaSeleccionConsorcios.vue?vue&type=script&lang=js"
import style0 from "./VistaSeleccionConsorcios.vue?vue&type=style&index=0&id=2dbb81be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VForm,VSwitch})
